import { render, staticRenderFns } from "./_content.vue?vue&type=template&id=a4b483c4"
import script from "./_content.vue?vue&type=script&lang=js"
export * from "./_content.vue?vue&type=script&lang=js"
import style0 from "./_content.vue?vue&type=style&index=0&id=a4b483c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports